export default __webpack_public_path__ + "static/media/thinkingcat.0eebd63d.png";